import { useMemo } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { criarTema } from '@anery/design-system';

import { usePreferencias } from '../shared/preferencias/usePreferencias';

/**
 * A densidade escolhida pela pessoa é o que monta o tema. Recriar o tema
 * a cada render seria desperdício e faria o emotion reinjetar tudo, então
 * ele é memoizado pela densidade — que é a única entrada que ele tem.
 */
export function ProvedorDeTema({ children }: { children: React.ReactNode }): React.JSX.Element {
  const densidade = usePreferencias((estado) => estado.densidade);
  const tema = useMemo(() => criarTema(densidade), [densidade]);

  return (
    <ThemeProvider theme={tema}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
